import React, { useEffect } from 'react';
import { Card, Progress, Statistic, Row, Col, Typography, Skeleton, Spin } from 'antd';
import { useDispatch } from 'react-redux';
import { getData } from '../../../actions/apiCall';
import moment from 'moment';

const { Title } = Typography;

interface TargetData {
    target: number;
    achieved: number;
    remaining: number;
    percentage: number;
}

interface BdeStatsData {
    bdeId: string;
    period: string;
    startDate: string;
    endDate: string;
    targets: {
        revenue: TargetData;
        deals: TargetData;
        accounts: TargetData;
    };
}

const BdeStatsDashboard: React.FC<{ stats: BdeStatsData | null, only: 'revenue' | 'deals' | 'accounts' }> = ({ stats, only }) => {

    const renderCard = (data?: TargetData, isMoney = false) => {
        if (!data) return <Skeleton active paragraph={{ rows: 2 }} />;
        return (
            <div className="p-2">
                <div className="flex justify-between items-center mb-2">
                    <Statistic
                        title="Target"
                        value={isMoney ? `₹${data.target.toLocaleString()}` : data.target}
                    />
                    <Statistic
                        title="Achieved"
                        value={isMoney ? `₹${data.achieved.toLocaleString()}` : data.achieved}
                    />
                </div>
                <Progress
                    percent={data.percentage > 100 ? 100 : data.percentage}
                    status={data.percentage >= 100 ? 'success' : 'active'}
                    strokeColor={data.percentage >= 100 ? '#52c41a' : '#1890ff'}
                />
                <p className={`text-sm text-gray-500 mt-2 ${data.remaining === 0 ? '' : 'text-red-500'}`}>
                    Remaining: {isMoney ? `₹${data.remaining.toLocaleString()}` : data.remaining}
                </p>
            </div>
        );
    };

    return (
        <div
            className="p-4 bg-white"
        >
            <>
                <Row gutter={[16, 16]}>
                    {only == 'revenue' && (
                        <Col span={24}>
                            {renderCard(stats.targets.revenue, true)}
                        </Col>
                    )}
                    {only == 'deals' && (
                        <Col span={24}>
                            {renderCard(stats.targets.deals)}
                        </Col>
                    )}
                    {only == 'accounts' && (
                        <Col span={24}>
                            {renderCard(stats.targets.accounts)}
                        </Col>
                    )}
                </Row>
            </>
        </div>
    );
};

export default BdeStatsDashboard;
